"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
var MenuDivider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuDivider, _Component);

  function MenuDivider() {
    (0, _classCallCheck2["default"])(this, MenuDivider);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuDivider).apply(this, arguments));
  }

  (0, _createClass2["default"])(MenuDivider, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("li", {
        className: "spectrum-Menu-divider",
        role: "separator"
      });
    }
  }]);
  return MenuDivider;
}(_react.Component);

exports["default"] = MenuDivider;
(0, _defineProperty2["default"])(MenuDivider, "displayName", 'MenuDivider');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react/react-spectrum/Menu/js/MenuDivider.js
// module id = 815
// module chunks = 0